import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ParentRoute } from './routes';

// const { worker } = require('./mocks/browser')
// worker.start()

ReactDOM.render(
	<React.StrictMode>
		<ParentRoute />
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
